import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";

import "../../assets/css/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useAsaSession, useIsLoading, useAsaSessionPagesMutation, useBackButton } from '../../services/AsaSessionServices'

import { useActiveSubscriptions, useSubscriptionsPlans, useFintechLayouts,useSubscriptionPurchaseMutation } from '../../services/AsaApiServices'
import { IAsaSession, Plan, SessionPage,SubscriptionDetail } from "../../types/types";

import LoaderComponent from "../../components/LoaderComponent";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";


import { useTranslation } from "react-i18next";


interface IFeatureItemProps {
  text: string;
}

const checkedIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g >
    <path d="M10.5808 14.1463L8.25775 11.823C8.11925 11.6847 7.94517 11.6138 7.7355 11.6105C7.526 11.6073 7.34875 11.6782 7.20375 11.823C7.05892 11.968 6.9865 12.1437 6.9865 12.35C6.9865 12.5563 7.05892 12.732 7.20375 12.877L9.948 15.6212C10.1288 15.8019 10.3398 15.8923 10.5808 15.8923C10.8218 15.8923 11.0327 15.8019 11.2135 15.6212L16.777 10.0578C16.9153 9.91925 16.9862 9.74517 16.9895 9.5355C16.9927 9.326 16.9218 9.14875 16.777 9.00375C16.632 8.85892 16.4563 8.7865 16.25 8.7865C16.0437 8.7865 15.868 8.85892 15.723 9.00375L10.5808 14.1463ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill="#1A7BFF"/>
  </g>
</svg>
);  

const FeatureItem: React.FC<IFeatureItemProps> = ({ text }) => {
  return (
    <>
    <div className="flex flex-row items-center mb-3 mt-3 ">
      <div className="mr-3">
        {checkedIcon()}
      </div>
      <div>
        <span className="text-[#4E4E4E] dark:text-white font-poppins text-sm font-medium leading-5 tracking-[-0.1px]">{text}</span>
      </div>
    </div>
    <div className="w-full">
      <hr className="border-gray-400"></hr>
    </div>
    </>
  );
};

export default function TykrLanding() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, ] = useIsLoading();

  const { data: session } = useAsaSession()
  const { data: subscriptions } = useActiveSubscriptions()
  const { data: subscriptionsPlans } = useSubscriptionsPlans()
  const sessionMutation = useAsaSessionPagesMutation()

  const handleBackClick = useBackButton()
  const layout = useFintechLayouts()
  const [isShowBackButton, setIsShowBackButton] = useState(true);
  
  const subscriptionPurchaseMutation= useSubscriptionPurchaseMutation()
  const [isContinueMode, setIsContinueMode] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const activeSubscription= subscriptions?.findLast(x=>x.subscriptionStatus="Active") as SubscriptionDetail;

  const [isFading, setIsFading] = useState(false);
  const fadeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const formattedRecurringAmount =
    selectedPlan?.recurringAmount != null
      ? Number(selectedPlan.recurringAmount).toFixed(2)
      : "0.00";

  const isTrialEligible=selectedPlan?.isConsumerEligibleForTrial??false;


  useEffect(() => {
    AnalyticsService.track("Tykr Landing Viewed", AnalyticsAction.View, AnalyticsFeature.Tykr, {
      subscriptionName: activeSubscription?.subscriptionTitle,
      price: activeSubscription?.billingAmount,
    });
  }, []);

  useEffect(() => {
    if(!!activeSubscription){
      const currentPlan = subscriptionsPlans?.find(plan => plan.subscriptionPlanCode === activeSubscription.subscriptionPlanCode) ?? null;
      setSelectedPlan(currentPlan);
     
    }
    else if(subscriptionsPlans && subscriptionsPlans.length > 0) {
      
      setSelectedPlan(subscriptionsPlans.find(plan => plan.billingCycle==='Monthly')??null  );
    }
    return () => {
      if (fadeTimeoutRef.current) {
        clearTimeout(fadeTimeoutRef.current);
      }
    };
  }, [subscriptionsPlans,activeSubscription]);

  const handleSelectBilling = (billing: "Monthly" | "Annually") => {
    if (selectedPlan?.billingCycle === billing) return;
    AnalyticsService.track("Tykr Billing Toggle Clicked", AnalyticsAction.Click, AnalyticsFeature.Tykr, {
      billingCycle: billing,
    });
    setIsFading(true);
    if (fadeTimeoutRef.current) clearTimeout(fadeTimeoutRef.current);
    fadeTimeoutRef.current = setTimeout(() => {
      setSelectedPlan(subscriptionsPlans?.find(plan => plan.billingCycle === billing) ?? null);
      setIsFading(false);
    }, 180); // half of 300ms transition for smoother swap
  };

  const getFeathuresList = (plan:Plan | null):string[] => {
    return [
      t("tykrFeatureStocks"),
      t("tykrFeatureETFs"),
      t("tykrFeatureCrypto"),
      t("tykrFeatureWatchlists"),
    
      t("tykrFeaturePortfolioTracker"),
      t("tykrFeatureAlerts"),
      t("tykrFeatureBrokerConnections"),
      t("tykrFeatureWeeklyTradeIdeas"),
      t("tykrFeatureRealTimePricing")
    ];
  }

 
  

  const handleProceed = async (
    plan: Plan | null,
  ) => {

  if(activeSubscription?.subscriptionPlanCode===plan?.subscriptionPlanCode ){
    navigate("/manageSubscriptions");
    return;
  }
    const sessionToUpdate: IAsaSession = { ...session } as IAsaSession
    sessionToUpdate.sessionPages = undefined
    const sessionpages = [] as SessionPage[]
    sessionpages.push({
      pageNumber: 2,
      pageName: "GOALS PLANS",
      pageTitle: "Select Package",
      pageDescription: "Select Package",
      pageUrl: "/tykr",
      pageStatusMessage: "INCOMPLETE",
      pageData: JSON.stringify(plan)
    } as SessionPage)
    sessionpages.push({
      pageNumber: 81,
      pageName: 'Landingyes',
      pageTitle: 'Landingyes',
      pageDescription: 'Landingyes',
      pageUrl: '/tykr',
      pageData: JSON.stringify({ Landing: "true" })
    } as SessionPage
    )

   
    try {

      const response = await sessionMutation.mutateAsync({ asaSession: sessionToUpdate, extraPages: sessionpages })
      AnalyticsService.track("Tykr Proceed Success", AnalyticsAction.API_Result, AnalyticsFeature.Tykr, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });
      navigate("/subscriptionpayment");
      return response;
    } catch (error) {
      AnalyticsService.track("Tykr Proceed Error", AnalyticsAction.API_Result, AnalyticsFeature.Tykr, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });

      console.error("Error updating session:", error);

    }
  };
  // Handling Update Session response
const startButtonText=!!!activeSubscription  ? 
  !isTrialEligible? selectedPlan?.billingCycle==='Monthly' ? t("startMonthly"):t("startAnnual") 
  : t("startFreeTrial"):
  (activeSubscription?.subscriptionPlanCode===selectedPlan?.subscriptionPlanCode ?("manage") :("upgrade"))

  const classnamesFading=`transition-opacity duration-300 ease-in-out ${isFading ? "opacity-0" : "opacity-100"}`
  return (
    <div className="flex justify-center items-center overflo h-screen">
      <LoaderComponent />
      <div className="w-full h-full flex flex-col  text-white relative z-20"
        style={layout?.backGroundStyle}>
         
        <div className="flex items-center justify-between p-4 mt-2 h-[72px]">
        { isShowBackButton && 
          <span className="back-arrow"
            style={layout?.buttonStyle}>
            <img
              alt="back"
              onClick={handleBackClick}
              className="cursor-pointer p-2 shadow-2xl rounded-lg w-7 h-7"
              src={arrow_back_ios_new}
            />
          </span>
      }
        </div>
          
        <div
          className="flex-grow relative rounded-t-3xl mt-6 p-6 flex flex-col bg-[#EBECF0] dark:bg-[#121212]"
          
        >
       
          <div className="flex justify-center items-center -mt-20">
            <img
              alt="TYKR"
              src={layout?.appIcon}
              className="w-20 h-20 rounded-2xl"
            />
          </div>
          <div className="flex flex-grow flex-col  mt-2">
            <div className="flex flex-col">
              <span className="text-[#4E4E4E] dark:text-[#FDFDFD] font-poppins text-center text-xl/5 font-bold">
               {layout?.appName ?? "Tykr"}
            </span>
            </div>

              <div className="flex flex-row w-full my-2 text-sm  font-poppins leading-5 tracking-[-0.1px] items-center">
                <div className={"text-right mx-2 w-1/2 my-4 text-[#4E4E4E] dark:text-[#D8D8D8] cursor-pointer "+(selectedPlan?.billingCycle==='Monthly'?"font-bold":"")}
                  onClick={()=>handleSelectBilling("Monthly")}
                >
                {t("monthly")}
                </div>
                <div className="h-6 w-px bg-gray-400 dark:bg-gray-600"></div>
               <div className={"text-left mx-2 w-1/2 my-4 text-[#4E4E4E] dark:text-[#D8D8D8] cursor-pointer "+ (selectedPlan?.billingCycle==='Annually'?"font-bold":"")}
                  onClick={()=>handleSelectBilling("Annually")}
               >
                {t("annually")}
                </div>
              </div>
               <div
                 className={`px-5 flex flex-col  bg-[#FFFFFF] dark:bg-[#2C2C2C] rounded-lg p-4 shadow-md overflow-y-scroll max-h-[50vh] no-scrollbar z-20 ${classnamesFading}`}
                 id="tyrkbody"
               >
                  <div className=" text-[#1A7BFF]  w-full  font-poppins text-lg font-medium leading-5 tracking-[-0.1px]">
                    {selectedPlan?.subscriptionTitle} 
                  </div>
                  <div className="mt-3 text-[#4E4E4E] dark:text-white font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                    {selectedPlan?.description}
                  </div>
                {getFeathuresList(selectedPlan).map((feature, index) => (
                    <FeatureItem key={index} text={feature} />
                  ))}
               </div>
              {isContinueMode &&
                <div
                  className="text-center -mt-1 px-5 py-2 flex flex-col font-poppins dark:bg-[#242424] bg-[#CCCCCC] text-[#1A7BFF] rounded-b-lg p-4 shadow-md  ">
                  {t("tykrExclusiveDealAsaUsers")}
                </div>
              }

        <div className="flex flex-col flex-1  items-center justify-end w-full mb-4">
          {!isContinueMode && (
            <div
              onClick={() => {
                AnalyticsService.track("Tykr Continue Clicked", AnalyticsAction.Click, AnalyticsFeature.Tykr, {
                  subscriptionName: selectedPlan?.subscriptionTitle,
                  price: selectedPlan?.recurringAmount,
                });
                setIsContinueMode(true);
              }}
              className="text-center  dark:shadow-none shadow-[0_4px_6px_rgba(120,_120,_120,_0.7)]  w-full  text-white py-3 rounded-lg  font-poppins font-semibold uppercase"
              style={layout?.buttonStyle}
            >
              {t("continue")} 
            </div>
          )}
           {isContinueMode && (
            <>
            <div className={`my-2' ${classnamesFading}`}>
              <span className="text-[#4E4E4E] dark:text-white text-center font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                {`$${formattedRecurringAmount} ${selectedPlan?.billingCycle==='Monthly'?t("perMonth"):t("perYear")} `}
              </span>
              <span className="text-[#4E4E4E] dark:text-white font-poppins text-sm font-bold leading-5 tracking-[-0.1px]">
                75% OFF
              </span>
            </div> 
            <div
              onClick={() => handleProceed(selectedPlan)}
              className="text-center  dark:shadow-none shadow-[0_4px_6px_rgba(120,_120,_120,_0.7)]  w-full  text-white py-3 rounded-lg  font-poppins font-semibold uppercase"
              style={layout?.buttonStyle}
            >
            {startButtonText} 
            </div>
            <div className="my-2">
              <span className="text-[#4E4E4E] dark:text-white text-center font-poppins text-sm font-normal leading-5 tracking-[-0.1px]">
                {t("cancelAnytime")}
              </span>
            </div>  
            </>
          )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
